import React from "react";
import { useIsTouch } from "@/hooks/useIsTouch";

// Floating proximity prompt above an active/nearby interactive object.
// Adapts to the input device: keyboard users see ENTER, touch users see TAP.
export const InteractPrompt = () => {
  const touch = useIsTouch();
  return (
    <div
      data-testid="interact-prompt"
      className="animate-float-prompt absolute -top-9 left-1/2 -translate-x-1/2 whitespace-nowrap rounded-md border-2 border-kirana-brown bg-kirana-gold px-2.5 py-1 text-xs font-bold text-kirana-brown hard-shadow-sm"
    >
      {touch ? "👆 TAP" : "⏎ ENTER"}
    </div>
  );
};
